export const READER_FONTS = {
  'source-han-serif': { label: '思源宋体', family: 'Margin SourceHanSerif', fallback: 'serif' },
  'wenkai': { label: '霞鹜文楷', family: 'Margin WenKai', fallback: 'serif' },
  'neo-zhisong': { label: '霞鹜新致宋', family: 'Margin NeoZhiSong', fallback: 'serif' },
  'zhuque': { label: '朱雀仿宋', family: 'Margin Zhuque', fallback: 'serif' },
  'source-han-sans': { label: '思源黑体', family: 'Margin SourceHanSans', fallback: 'sans-serif' },
  'neo-xihei': { label: '霞鹜新晰黑', family: 'Margin NeoXiHei', fallback: 'sans-serif' },
} as const;

export type ReaderFont = keyof typeof READER_FONTS;
export const DEFAULT_READER_FONT: ReaderFont = 'source-han-serif';

export function readerFont(value: unknown): ReaderFont {
  return typeof value === 'string' && Object.hasOwn(READER_FONTS, value)
    ? value as ReaderFont : DEFAULT_READER_FONT;
}

let fontRequest = 0;
export function applyReaderFont(font: ReaderFont, ipaOriginals = false) {
  const choice = ipaOriginals && font === 'neo-xihei'
    ? { label: 'IPAex Gothic', family: 'Margin IPAexGothic', fallback: 'sans-serif' }
    : ipaOriginals && font === 'neo-zhisong'
      ? { label: 'IPAex Mincho', family: 'Margin IPAexMincho', fallback: 'serif' }
      : READER_FONTS[font];
  document.documentElement.dataset.readerFont = font;
  document.documentElement.style.setProperty('--font-reading', `"${choice.family}", ${choice.fallback}`);
  const status = document.getElementById('fontStatus');
  const request = ++fontRequest;
  if (status) status.textContent = `正在载入${choice.label}…`;
  // Only the selected reading face is fetched. FontFaceSet reuses the browser cache.
  void document.fonts.load(`400 18px "${choice.family}"`, '书页之间').then((loaded) => {
    if (status && request === fontRequest) {
      status.textContent = loaded.length ? `已应用${choice.label}` : '字体未能载入，暂用系统字体';
    }
  }).catch(() => {
    if (status && request === fontRequest) status.textContent = '字体未能载入，暂用系统字体；刷新页面后重试';
  });
}
